// var controlText = require('./text'),
//     controlButton = require('./button'),
//     controlTextarea = require('./textarea'),
//     controlFile = require('./file'),
//     controlRadioGroup = require('./radiogroup');

module.exports = [
    require('./text'),
    require('./button'),
    require('./textarea'),
    require('./file'),
    require('./checkboxgroup'),
    require('./radiogroup'),
    require('./select')
];